import {
  collection,
  where,
  getFirestore,
  getDocs,
  query,
  setDoc,
  getDoc,
  deleteDoc,
  serverTimestamp,
  doc,
  updateDoc,
  orderBy,
  onSnapshot,
} from "firebase/firestore";
import { getAuth } from "firebase/auth";
import moment from "moment";
import { app } from "../../config/config";
import { REF } from "../ref";
import { TYPES } from "./time_tracking.type";
import { update } from "lodash";

const firestore = getFirestore(app);
const auth = getAuth();

// -------------- select the time Tracking ------------------- //
let timeSub = [];
export const snapAllTimeTracking =
  ({ from, to, company }, callback) =>
  (dispatch) => {
    const owner = auth?.currentUser?.uid;
    const cRef = collection(firestore, REF.TIME_TRACKING);
    const start = from?._d;
    const end = to?._d;
    // const start = moment(from).startOf("day").toDate();
    // const end = moment(to).endOf("day").toDate();
    const c0 = where("owner", "==", owner);
    const c1 = where("checkedAt", ">=", start);
    const c2 = where("checkedAt", "<=", end);
    const c3 = where("branch", "==", company);
    const qRef = query(cRef, c0, c1, c2, c3);
    const unsub = onSnapshot(qRef, (snapshot) => {
      if (snapshot) {
        const data = snapshot?.docs.map((doc) => doc.data());
        // selectAllSuccess(dispatch, data);
        if (callback) {
          callback(data);
        }
      }
    });
    timeSub.push(unsub);
  };

export const unSnapTime = () => (dispatch) => {
  timeSub.forEach((subscriber) => {
    subscriber();
  });
  timeSub.length = 0;
};

// -------------- dispatch ------------------- //
const selectAllSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SELECT_ALL_TRACKING_SUCCESS,
    payload: data,
  });
};

// -------------- select the date Tracking ------------------- //
let dateSub = [];
export const snapDateTracking =
  ({ date, branch, user }, callback) =>
  (dispatch) => {
    // selectDateSuccess(dispatch, null);
    const owner = auth?.currentUser?.uid;
    const dateString = date && date?.format("DD/MM/YYYY");
    const cRef = collection(firestore, REF.TIME_TRACKING);
    const c0 = where("owner", "==", owner);
    const c1 = where("branch", "==", branch);
    const c2 = where("user", "==", user);
    const c3 = where("date", "==", dateString);
    const qRef = query(cRef, c0, c1, c2, c3);
    const unsub = onSnapshot(qRef, (snapshot) => {
      if (snapshot) {
        const data = snapshot.docs.map((doc) => doc.data());
        // selectDateSuccess(dispatch, data);
        if (callback) {
          callback(data);
        }
      }
    });
    dateSub.push(unsub);
  };

export const unSnapDate = (callback) => (dispatch) => {
  dateSub.forEach((subscriber) => {
    subscriber();
  });
  dateSub.length = 0;
};

export const resetDate = (callback) => (dispatch) => {
  selectDateSuccess(dispatch, null);
  if (callback) {
    callback();
  }
};

// -------------- dispatch ------------------- //
const selectDateSuccess = (dispatch, data) => {
  dispatch({
    type: TYPES.SELECT_DATE_TRACKING_SUCCESS,
    payload: data,
  });
};

// -------------- add time Tracking------------------- //

export const addTime =
  ({ user, date, time, branch }, callback) =>
  (dispatch) => {
    const cRef = collection(firestore, REF.TIME_TRACKING);
    const id = doc(cRef).id;
    const dRef = doc(cRef, id);
    const timeString = time?.format("hh:mm A");
    const dateString = date?.format("DD/MM/YYYY");

    const checkedAt = moment(
      `${dateString} ${timeString}`,
      "DD/MM/YYYY hh:mm A"
    )._d;

    const owner = auth?.currentUser?.uid;
    const data = {
      id,
      createAt: serverTimestamp(),
      checkedAt,
      date: dateString,
      user,
      owner,
      branch,
      screenshot: "",
      subUrl: "",
      longitude: "",
      latitude: "",
    };

    setDoc(dRef, data, { merge: true });
  };

// -------------- delete time tracking------------------- //
export const deleteTimeTracking =
  ({ id }, callback) =>
  (dispatch) => {
    const cRef = collection(firestore, REF.TIME_TRACKING);
    const dRef = doc(cRef, id);
    deleteDoc(dRef).then(() => {});
  };

// -------------- update time tracking------------------- //
export const updateTimeTracking =
  ({ selected, branch }, callback) =>
  (dispatch) => {
    const cRef = collection(firestore, REF.TIME_TRACKING);

    selected.forEach((item) => {
      const action = item?.action;

      //create data;
      if (action === "create") {
        const id = doc(cRef).id;
        const dRef = doc(cRef, id);
        const owner = auth?.currentUser?.uid;
        const timeCheckAt = item?.time && item?.time?.format("hh:mm A");
        const date = item?.date;
        const checkedAt = moment(
          `${date} ${timeCheckAt}`,
          "DD/MM/YYYY hh:mm A"
        )?._d;
        const user = item?.user;

        const data = {
          id,
          createAt: serverTimestamp(),
          checkedAt,
          date,
          user,
          owner,
          branch,
          screenshot: "",
          subUrl: "",
          longitude: "",
          latitude: "",
        };

        setDoc(dRef, data, { merge: true });
      }

      //Update the data
      if (action === "update") {
        const id = item?.id;
        const dRef = doc(cRef, id);
        const checkedAt = item?.time && item?.time._d;
        const update = {
          checkedAt,
        };
        updateDoc(dRef, update);
      }

      //delete the data
      if (action === "delete") {
        const id = item?.id;
        const dRef = doc(cRef, id);
        deleteDoc(dRef);
      }
    });

    if (callback) {
      callback();
    }
  };
